export const formatDateTime = (value?: string) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString();
};

export const toLightVariant = (light?: string) => {
    if (light === "green") return "success" as const;
    if (light === "amber" || light === "yellow") return "warning" as const;
    return "danger" as const;
};

export const toLightClass = (light?: string) => {
    if (light === "green") return "summary-light-green";
    if (light === "amber") return "summary-light-amber";
    return "summary-light-red";
};

export const prettifyKey = (value: string) =>
    value
        .replace(/_/g, " ")
        .replace(/\b\w/g, (m) => m.toUpperCase());
